import { render } from "./Ergebniss.vue?vue&type=template&id=2de955b8"
import script from "./Ergebniss.vue?vue&type=script&lang=js"
export * from "./Ergebniss.vue?vue&type=script&lang=js"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__